import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Skeleton, VerticalSpace } from '@arc-ui/components';

export const FacetSkeleton: React.FC = () => {
  const keys = React.useMemo(
    () => Array.from({ length: 5 }, () => uuidv4()),
    [],
  );

  return (
    <div data-testid="facet-skeleton">
      <Skeleton width="70%" height={18} animation="pulse" />
      <VerticalSpace size="16" />
      {keys.map((key) => (
        <div key={key} style={{ margin: '6px 0' }}>
          <Skeleton width="100%" height={28} animation="pulse" />
        </div>
      ))}
    </div>
  );
};

export const ResultSkeleton: React.FC = () => (
  <div data-testid="result-skeleton">
    <Skeleton width="55%" height={18} animation="pulse" />
    <VerticalSpace size="4" />
    <Skeleton width="90%" height={12} animation="pulse" />
    <VerticalSpace size="4" />
    <Skeleton width="80%" height={12} animation="pulse" />
    <VerticalSpace size="16" />
  </div>
);
